module.exports = __webpack_public_path__ + "img/visuel@3x.0a995a2a.webp";